import { Tag, TagProps } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { UserStatus } from '@mews-commander/data-access';

const mapStatusToTagProps: Record<UserStatus, TagProps> = {
    [UserStatus.Active]: {
        variant: 'lime',
        children: <LocalizedText textKey={TextKey.UserStatusActive} />,
    },
    [UserStatus.Pending]: {
        variant: 'mustard',
        children: <LocalizedText textKey={TextKey.UserStatusPending} />,
    },
    [UserStatus.Disabled]: {
        variant: 'basicSubtle',
        children: <LocalizedText textKey={TextKey.UserStatusDisabled} />,
    },
    [UserStatus.Inactive]: {
        variant: 'basicSubtle',
        children: <LocalizedText textKey={TextKey.UserStatusInactive} />,
    },
};

export const UserStatusTag = ({ status }: { status: UserStatus }) => <Tag {...mapStatusToTagProps[status]} outline />;
